import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import {DATEFORMAT_DATATABLE, DATEFORMAT_DATATABLE_TIME} from 'src/shared/constants';
import Helpers from 'src/shared/helpers';

@Component({
  selector: 'render-value',
  standalone: false,
  templateUrl: './render-value.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RenderValueComponent implements OnInit {
  dateFormatDataTable: typeof DATEFORMAT_DATATABLE = DATEFORMAT_DATATABLE;
  dateFormatDataTableTime: typeof DATEFORMAT_DATATABLE_TIME = DATEFORMAT_DATATABLE_TIME;

  @Input() data: any;
  @Input() template: string = 'string';
  @Input() classes: string = '';

  constructor() {}

  ngOnInit() {
    if (['decimal'].indexOf(this.template) !== -1) {
      this.classes += ' whitespace-nowrap';

      if (this.classes.indexOf('text-left') === -1) {
        this.classes += ' text-right';
      }
    }
  }

  toDecimal(value: string): number {
    return Helpers.toDecimal(value);
  }
}
